const numberValue = (value) => Math.max(0, Number(value) || 0);

export const getVehicleDailyRate = (car, rateType = "limited") =>
  numberValue(
    rateType === "unlimited"
      ? car?.defaultUnlimitedRatePerDay
      : car?.defaultRatePerDay
  );

const isAvailableForRequestedDates = (car) => {
  if (!car || car.isActive === false || car.status === "out-of-service") return false;
  if (car.isUnavailable || car.isSold || car.isFullyBooked) return false;
  if (car.availabilityStatus && car.availabilityStatus !== "available") return false;
  return car.availableNow === undefined || numberValue(car.availableNow) > 0;
};

export const rankAlternativeVehicles = (
  selectedCar,
  cars = [],
  rateType = "limited"
) => {
  if (!selectedCar?._id) return [];

  const selectedSeats = numberValue(selectedCar.seats);
  const selectedBags = numberValue(selectedCar.bags);
  const selectedRate = getVehicleDailyRate(selectedCar, rateType);

  return cars
    .filter(
      (candidate) =>
        candidate?._id !== selectedCar._id &&
        isAvailableForRequestedDates(candidate)
    )
    .map((candidate) => {
      const seats = numberValue(candidate.seats);
      const bags = numberValue(candidate.bags);
      const rate = getVehicleDailyRate(candidate, rateType);
      const seatShortfall = Math.max(0, selectedSeats - seats);
      const bagShortfall = Math.max(0, selectedBags - bags);
      const seatDifference = Math.abs(selectedSeats - seats);
      const bagDifference = Math.abs(selectedBags - bags);
      const priceDifference = selectedRate > 0 ? Math.abs(rate - selectedRate) : 0;

      let score = 100;
      score -= seatShortfall * 30;
      score -= bagShortfall * 18;
      score -= seatDifference * 4;
      score -= bagDifference * 3;
      score -= Math.min(20, priceDifference / 5);
      if (candidate.isAutomatic === selectedCar.isAutomatic) score += 10;
      if (seats >= selectedSeats) score += 8;
      if (bags >= selectedBags) score += 5;

      return {
        car: candidate,
        score,
        rate,
        reasons: [
          `${seats} seats`,
          `${bags} ${bags === 1 ? "bag" : "bags"}`,
          candidate.isAutomatic ? "Automatic" : "Manual",
        ],
      };
    })
    .sort(
      (a, b) =>
        b.score - a.score ||
        Math.abs(a.rate - selectedRate) - Math.abs(b.rate - selectedRate) ||
        (a.car.name || "").localeCompare(b.car.name || "")
    );
};
